import { render } from "./Dashboard.vue?vue&type=template&id=64d302b2&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=64d302b2&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=64d302b2&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d302b2"]])

export default __exports__